<template>
  <share-button :entity-type="entityType" :entity-slug="entitySlug" :channel-settings="channelSettings"
                :utm-medium="utmMedium" :share-url-from-url="shareUrlFromUrl" />
</template>

<script>
import ButtonMixin from './button-mixin'

export default {
  mixins: [ButtonMixin],

  methods: {
    shareUrlFromUrl(url) {
      let params = new URLSearchParams({link: url})
      params.append('app_id', this.channelSettings.appId)

      return `fb-messenger://share?${params.toString()}`
    }
  }
}
</script>
